if (typeof videoProvider !== 'undefined' && videoProvider == 'vidalytics') {
    //- Mobile detection function
    const mobileDetection = {
        // Check if it's a real mobile device
        isRealMobileDevice: () => {
            return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },

        // Check if it's a tablet device
        isTabletDevice: () => {
            return /iPad|Android(?!.*Mobile)|PlayBook/i.test(navigator.userAgent);
        },

        // Check if current viewport is mobile-sized (width < 768px)
        isMobileViewport: () => {
            return window.innerWidth < 768;
        },

        // Check if current viewport is tablet-sized (width >= 768px and <= 1024px)
        isTabletViewport: () => {
            return window.innerWidth >= 768 && window.innerWidth <= 1024;
        },

        // Check if current viewport is desktop-sized (width > 1024px)
        isDesktopViewport: () => {
            return window.innerWidth > 1024;
        },

        // Get current device type based on both device and viewport
        getCurrentDeviceType: () => {
            if (mobileDetection.isRealMobileDevice()) {
                return 'mobile';
            } else if (mobileDetection.isTabletDevice()) {
                return 'tablet';
            } else if (mobileDetection.isMobileViewport()) {
                return 'mobile-viewport';
            } else if (mobileDetection.isTabletViewport()) {
                return 'tablet-viewport';
            } else {
                return 'desktop';
            }
        },

        // Check if we should use mobile behavior (real mobile OR mobile viewport)
        shouldUseMobileBehavior: () => {
            return mobileDetection.isRealMobileDevice() || mobileDetection.isMobileViewport();
        },

        // Check if we should use tablet behavior (real tablet OR tablet viewport)
        shouldUseTabletBehavior: () => {
            return mobileDetection.isTabletDevice() || mobileDetection.isTabletViewport();
        },

        // Check if we should use desktop behavior
        shouldUseDesktopBehavior: () => {
            return !mobileDetection.shouldUseMobileBehavior() && !mobileDetection.shouldUseTabletBehavior();
        }
    };

    //- Window resize handler for mobile detection
    let resizeTimeout;
    const handleWindowResize = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            const currentDeviceType = mobileDetection.getCurrentDeviceType();
            const previousDeviceType = window.previousDeviceType || 'unknown';

            // Only trigger if device type actually changed
            if (currentDeviceType !== previousDeviceType) {
                window.previousDeviceType = currentDeviceType;

                // Trigger custom event for device type change
                $(window).trigger('deviceTypeChanged', {
                    previousType: previousDeviceType,
                    currentType: currentDeviceType,
                    isMobile: mobileDetection.shouldUseMobileBehavior(),
                    isTablet: mobileDetection.shouldUseTabletBehavior(),
                    isDesktop: mobileDetection.shouldUseDesktopBehavior()
                });

                // You can add specific logic here for when device type changes
                const newVideoTiming = handleDeviceTypeChange(currentDeviceType, previousDeviceType);
                if (newVideoTiming) {
                    window.currentVideoTiming = newVideoTiming;
                }

                setVideoFullScreen(false); // Reset fullscreen state
            }
        }, 250); // Debounce resize events
    };

    //- Handle device type changes
    const handleDeviceTypeChange = () => {
        const isMobile = mobileDetection.shouldUseMobileBehavior();

        // Example: Reload video content when switching between mobile and desktop
        if (typeof personalizedContent !== 'undefined' && personalizedContent == true) {
            // Check if we have survey data to determine which video to load
            const answer = localStorage.getItem('triggerQuestion');

            if (answer && answer.trim() !== '') {
                // console.log('localStorage answer:', answer);

                // Find the matching video in personalizedContentList
                const videoObject = Object.entries(personalizedContentList).find(([key, val]) => key === answer);

                if (videoObject) {
                    const videoId = videoObject[1];
                    // console.log('videoId:', videoId);
                    const newVideoScript = buildVideoScript(embedId, isMobile ? videoId.mobile : videoId.desktop, isMobile ? videoRatio.mobileRatio : videoRatio.desktopRatio);
                    loadVideoScript(newVideoScript);

                    let videoTiming = isMobile ? videoId.mobileTiming : videoId.desktopTiming;

                    // Store videoTiming globally for use in attachListenersToVideo
                    window.currentVideoTiming = videoTiming;
                    return videoTiming;
                }
            } else {
                // console.log('No matching video found for:', answer, 'using default');
                const videoId = personalizedContentList.default;
                // console.log('videoId for:', videoId);
                if (!videoId) return;

                const newVideoScript = buildVideoScript(embedId, isMobile ? videoId.mobile : videoId.desktop, isMobile ? videoRatio.mobileRatio : videoRatio.desktopRatio);
                loadVideoScript(newVideoScript);

                let videoTiming = isMobile ? videoId.mobileTiming : videoId.desktopTiming;

                // Store videoTiming globally for use in attachListenersToVideo
                window.currentVideoTiming = videoTiming;
                return videoTiming;
            }
        }
    };

    //- Initialize device type
    window.previousDeviceType = mobileDetection.getCurrentDeviceType();

    //- Bind resize event
    $(window).on('resize', handleWindowResize);

    // Initialize video timing on page load
    const initialVideoTiming = handleDeviceTypeChange();
    if (initialVideoTiming) {
        window.currentVideoTiming = initialVideoTiming;
    }

    //- Handle cookies for VSL Play button
    function addCookie() {
        if (!$.cookie('sunCoast_returnUser')) {
            setTimeout(() => {
                $.cookie("sunCoast_returnUser", 1, { expires: 7 });
            }, 3000);

        } else {
            $("#vslCTA").removeClass('hidden');
        }
    }

    //- Storage cookie / show CTA when page is loaded
    addCookie();

    // Build Video script
    // VideoRatio prevents video UI from jumping size when loading
    function buildVideoScript(embedId, videoId, aspectRatio) {
        return '<div id="vidalytics_embed_' + videoId +'" style="width: 100%; position:relative; padding-top: ' + aspectRatio + ';"></div>' +
        '<script type="text/javascript">' +
        '(function (v, i, d, a, l, y, t, c, s) {' +
        'y=\'_\'+d.toLowerCase();c=d+\'L\';if(!v[d]){v[d]={};}if(!v[c]){v[c]={};}if(!v[y]){v[y]={};}var vl=\'Loader\',vli=v[y][vl],vsl=v[c][vl + \'Script\'],vlf=v[c][vl + \'Loaded\'],ve=\'Embed\';' +
        'if (!vsl){vsl=function(u,cb){' +
        'if(t){cb();return;}s=i.createElement("script");s.type="text/javascript";s.async=1;s.src=u;' +
        'if(s.readyState){s.onreadystatechange=function(){if(s.readyState==="loaded"||s.readyState=="complete"){s.onreadystatechange=null;vlf=1;cb();}};}else{s.onload=function(){vlf=1;cb();};}' +
        'i.getElementsByTagName("head")[0].appendChild(s);' +
        '};}' +
        'vsl(l+\'loader.min.js\',function(){if(!vli){var vlc=v[c][vl];vli=new vlc();}vli.loadScript(l+\'player.min.js\',function(){var vec=v[d][ve];t=new vec();t.run(a);});});' +
        '})(window, document, \'Vidalytics\', \'vidalytics_embed_' + videoId + '\', \'https://quick.vidalytics.com/embeds/' + embedId + '/' + videoId + '/\');' +
        '</script>';
    };

    //- Function to load HTML content into video div
    function loadVideoScript(content) {
        const videoContainer = $('.video');
        if (videoContainer.length) {
            // Clear existing content
            videoContainer.empty();

            // Create a temporary div to parse the HTML content
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = content;

            // Extract script tags before adding content to DOM
            const scripts = tempDiv.querySelectorAll('script');
            const scriptElements = [];

            // Store script elements and remove them from temp div
            scripts.forEach(function (script) {
                const newScript = document.createElement('script');
                newScript.type = script.type || 'text/javascript';
                if (script.src) {
                    newScript.src = script.src;
                }
                if (script.innerHTML) {
                    newScript.innerHTML = script.innerHTML;
                }
                scriptElements.push(newScript);
                script.remove();
            });

            // Add the HTML content (without scripts) to the video container
            videoContainer.html(tempDiv.innerHTML);

            // Execute scripts after content is loaded
            scriptElements.forEach(function (script) {
                videoContainer.append(script);
            });

            // Listen for video ready event
            window.addEventListener('videoReady', ((event) => {
                const videoElement = event.detail.video;
                if (videoElement) {
                    attachListenersToVideo(videoElement, window.currentVideoTiming);
                }
            }));

            // Ensure event listeners attach on play
            document.addEventListener("play", (event) => {
                const target = event.target;
                if (target && target.tagName === "VIDEO") {
                    attachListenersToVideo(target, window.currentVideoTiming);
                    forceScrollToTop();

                    if (typeof isFullScreen !== 'undefined' && isFullScreen === true) {
                        setVideoFullScreen(true);
                    }
                }
            }, true);

            // Ensure event listeners attach on pause
            document.addEventListener("pause", (event) => {
                const target = event.target;
                if (target && target.tagName === "VIDEO") {
                    setVideoFullScreen(false);
                }
            }, true);

            // Force event listeners to attach when user interacts
            document.addEventListener("touchstart", forceMobileListeners, { once: true });
            document.addEventListener("click", forceMobileListeners, { once: true });
        }
    };

    // Force mobile listeners for iOS compatibility
    function forceMobileListeners() {
        setTimeout(() => {
            const playerElement = document.querySelector('video');
            if (playerElement) {
                attachListenersToVideo(playerElement, window.currentVideoTiming);
            }
        }, 500); // Delay to ensure video is initialized
    };

    // Attach listeners to video element
    function attachListenersToVideo(video, videoTiming) {
        let isTimeTrapTriggered = false;

        // Use the passed videoTiming parameter or fall back to global currentVideoTiming
        const timingToUse = videoTiming || window.currentVideoTiming;
        const buttonTime = Math.floor(getVideoTimeToShowNextStepButton(timingToUse));

        // Use setInterval for more reliable time checking
        const timeCheckInterval = setInterval(() => {
            const currentTime = Math.floor(video.currentTime);
            if (!isTimeTrapTriggered && currentTime >= buttonTime) {
                isTimeTrapTriggered = true;
                handleNextStepButton();
                clearInterval(timeCheckInterval);
            }
        }, 1000);

        video.addEventListener("timeupdate", () => {
            const currentTime = Math.floor(video.currentTime);
            if (!isTimeTrapTriggered && currentTime >= buttonTime) {
                isTimeTrapTriggered = true;
                handleNextStepButton();
                clearInterval(timeCheckInterval);
            }
        });

        video.addEventListener("seeked", () => {
            const currentTime = Math.floor(video.currentTime);
            if (currentTime >= buttonTime) {
                isTimeTrapTriggered = true;
                handleNextStepButton();
                clearInterval(timeCheckInterval);
            }
        });

        // Add play event listener to ensure we catch timing after user interaction
        video.addEventListener("play", () => {
            const currentTime = Math.floor(video.currentTime);
            if (!isTimeTrapTriggered && currentTime >= buttonTime) {
                isTimeTrapTriggered = true;
                handleNextStepButton();
                clearInterval(timeCheckInterval);
            }
        });
    }

    function setVideoFullScreen(isFullscreen) {
        $("body").toggleClass("video--fullscreen", isFullscreen);
    }

    function getVideoTimeToShowNextStepButton(videoTiming) {
        // If videoTiming is undefined, try to get it from global variable
        const timingToUse = videoTiming || window.currentVideoTiming;

        if (!timingToUse) {
            console.warn('No videoTiming available, using default value');
            return 0; // or some default value
        }

        const isMobile = mobileDetection.shouldUseMobileBehavior();
        if (!isMobile) {
            return timingToUse;
        } else {
            return timingToUse;
        }
    }

    function handleNextStepButton() {
        const nextButton = $("#vslCTA");
        if (nextButton) {
            const isHidden = nextButton.hasClass("hidden");
            if (isHidden) {
                nextButton.removeClass("hidden");
            }
        }
    }

    // Force scroll to top when entering fullscreen
    function forceScrollToTop() {
        setTimeout(() => {
            document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
        }, 100);
    }

    document.addEventListener('keydown', function (event) {
        const video = document.querySelector('video');

        if (event.keyCode == 37) {
            video.currentTime = video.currentTime - 5;
        } else if (event.keyCode == 39) {
            video.currentTime = video.currentTime + 5;
        }
    });
}

if (typeof videoProvider !== 'undefined' && videoProvider == 'brightcove') {
    //- Handle one video time for all videos
    if (typeof timePlaying !== 'undefined' && timePlaying != '') {
        function addCookie() {
            if ($('#vslVideo').length && !$.cookie('sunCoast-video')) {
                videojs('vslVideo').ready(function () {
                    this.on('timeupdate', function () {
                        if (this.currentTime() >= (timePlaying) || this.currentTime() == this.duration()) {

                            if (typeof loadIframe !== 'undefined' && loadIframe == true) {
                                $("#vslContent").addClass('hidden');
                                $("#ecomIframe").removeClass('iframe__hidden');
                            } else {
                                $("#vslCTA").removeClass('hidden').addClass('visible');
                            }
                        }
                    })
                })

                $.cookie("sunCoast-video", 1, { expires: 7 });
            } else if ($('#vslVideo').length || $.cookie('sunCoast-video')) {
                if (typeof loadIframe !== 'undefined' && loadIframe == true) {
                    $("#vslContent").addClass('hidden');
                    $("#ecomIframe").removeClass('iframe__hidden');
                } else {
                    $("#vslCTA").removeClass('hidden').addClass('visible');
                }
            }
        }

        addCookie();
    }

    if (typeof isFullScreen !== 'undefined' && isFullScreen == true) {
        /**
         * Plays Video in Full Screen Mode and returns to normal when Paused
         */

        let isMobile = {
            iOS: function () {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            }
        }

        let player = videojs('vslVideo'),
            playButton = document.getElementsByClassName('vjs-big-play-centered')[0],
            playButtonDummy = document.getElementsByClassName('dummyButton')[0];

        if (!isMobile.iOS()) {
            // console.log('Android');

            playButtonDummy.addEventListener('click', function (e) {
                $(".vjs-big-play-centered").trigger('click');
            }, false);

            function playPauseAndFullscreen(e) {
                e.preventDefault();

                if (player.hasClass('vjs-paused')) {
                    player.play();
                    player.requestFullscreen();
                }

                if (player.hasClass('vjs-playing')) {
                    player.pause();
                    player.exitFullscreen();
                }
            }

            if (player.hasClass('vjs-touch-enabled')) {
                // console.log('touch-enabled');

                playButton.addEventListener('touchstart', function (e) {
                    playPauseAndFullscreen(e);
                    // console.log('shoot touch')
                }, false);
            }

            if (player.hasClass('vjs-workinghover')) {
                // console.log('workinghover');

                playButton.addEventListener('click', function (e) {
                    playPauseAndFullscreen(e);
                    // console.log('shoot click')
                }, false);
            }
        }

        // Use default iOS behaviour
        if (isMobile.iOS()) {
            // console.log('iOS');
            playButtonDummy.style.display = "none";
        }
    }

    //- Play full video if clicked play button on thumbnail video (appears only if we have videoThumbnail string passed to vslSection component)
    $('#vslVideoThumb .vjs-big-play-button').on('click touchend', function () {
        const fullVideoUrl = $('#vslVideoThumb').data('full-video');
        $('#vslVideoThumb').attr('id', 'vslVideo');
        $('#vslVideo video').attr('src', fullVideoUrl);
        videojs('vslVideo').controls(true);
        videojs('vslVideo').play();
        videojs('vslVideo').muted(false);
        addCookie();
    });

    //- Different VSL on mobile and desktop
    const mobileVideoID = $('video-js').attr('data-video-id-mobile');

    const changeVslOnMobile = play => {
        if (typeof mobileVideoID !== 'undefined' && mobileVideoID != '') {
            let isMobileDevice = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            if (isMobileDevice) {
                const myPlayer = videojs.getPlayer('vslVideo')
                if (window.innerHeight > window.innerWidth) {
                    myPlayer.catalog.getVideo(mobileVideoID, function (error, video) {
                        myPlayer.catalog.load(video);
                        play ? myPlayer.play() : null;
                    });
                }
            }
        };
    };

    changeVslOnMobile();

    // Full screen Inline video
    if (typeof isFullScreenInline !== 'undefined' && isFullScreenInline == true) {
        const videoPlayer = videojs('vslVideo');
        videoPlayer.controls(false);

        let startScrollTop,
            endScrollTop;

        $(".video").on("touchstart", function () {
            startScrollTop = $(window).scrollTop();
        });

        $(".video").on('touchend', function () {
            endScrollTop = $(window).scrollTop();
        });

        $(".video").on('click touchend', function () {
            if (startScrollTop === endScrollTop) {
                window.scrollTo(0, 0);
                if ($('body').hasClass('video--fullscreen')) {
                    videoPlayer.pause();
                    $('.vjs-big-play-button').show();
                    $('body').removeClass('video--fullscreen');
                } else {
                    videoPlayer.play();
                    $('.vjs-big-play-button').hide();
                    $('body').addClass('video--fullscreen');
                };
            }
        });

        $(".video").one('click touchend', function () {
            changeVslOnMobile(true);
        });
    }
}